// removed by extract-text-webpack-plugin
module.exports = {"container":"RecordingTab-container","loadingContainer":"RecordingTab-loadingContainer"};